
export function initAiAura(wrapper = document){
    for(const aiAura of wrapper.querySelectorAll(".aiAura")){
        let angle = 0;
        const step = 360 / 50;
        setInterval(function () {
            angle += step;
            if (angle > 360) {
                angle = 0;
            }
            aiAura.setAttribute("style", `--angle: ${angle}deg`);
        }, 100);
    }
}